import script from "./RedimirCupon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RedimirCupon.vue?vue&type=script&setup=true&lang=ts"

import "./RedimirCupon.vue?vue&type=style&index=0&id=2d5d5eda&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d5d5eda"]])

export default __exports__